import { request } from '@/shared/api/request'

export const editWorkPlace = ({ data, params }) => {
	return request({
		method: 'POST',
		url: 'staff/workPlace/edit',
		data,
		params
	})
}
